import { render, staticRenderFns } from "./L20.vue?vue&type=template&id=0f1acaa8&scoped=true"
import script from "./L20.vue?vue&type=script&lang=js"
export * from "./L20.vue?vue&type=script&lang=js"
import style0 from "./L20.vue?vue&type=style&index=0&id=0f1acaa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1acaa8",
  null
  
)

export default component.exports